import { render, staticRenderFns } from "./DenunciationsInformations.vue?vue&type=template&id=614f48a0&scoped=true&"
import script from "./DenunciationsInformations.vue?vue&type=script&lang=js&"
export * from "./DenunciationsInformations.vue?vue&type=script&lang=js&"
import style0 from "./DenunciationsInformations.vue?vue&type=style&index=0&id=614f48a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614f48a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
